export default ({ request }) => ({
  mrpPlDeviceListApi(data = {}) {
    return request({
      url: '/factory/mrp/pl/device/list',
      method: 'post',
      data,
    })
  },
  mrpPlDeviceSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/pl/device/save',
      method: 'post',
      data,
    })
  },
  mrpPlDeviceImportApi(data = {}) {
    return request({
      url: '/factory/mrp/pl/device/import',
      method: 'post',
      data,
    })
  },
  mrpPlDeviceScrapApi(data = {}) {
    return request({
      url: '/factory/mrp/pl/device/scrap',
      method: 'post',
      data,
    })
  },
  mrpPlDeviceDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/pl/device/detail',
      method: 'post',
      data,
    })
  },
  mrpPlDeviceDelApi(data = {}) {
    return request({
      url: '/factory/mrp/pl/device/del',
      method: 'post',
      data,
    })
  },
})
